import React from 'react';
import { Link } from 'react-router-dom';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';  
import 'owl.carousel/dist/assets/owl.theme.default.css'; 


const TechnologyStack = () => {
    return (
        <div>
            <div>
  <div className="breadcrumb-banner-area" style={{backgroundImage: 'url(./img/service-header.png)'}}>
    <div className="container">
      <div className="row">
        <div className="col-md-12">
          <div className="breadcrumb-text text-center">
            <h2>Technology Stack</h2>
          </div>
        </div>
      </div>
    </div>
  </div>
  <br />
  <br />
  {/* breadcrumb-banner-area-end */}
  <div className="container">
    <div className="row mb-5">
      <div className="col-sm-12 col-md-6 align-self-center">
        <div>
          <h4><b>Our software engineering team works with the latest and greatest of web, mobile, and cross-platform technology. 
            </b></h4>
          <br />
          <p>Our technology expertise includes C++, .NET, RoR, Python, PHP and Java, along with frontend and other multi-disciplinary 
            expertise such as mobility. Combining them, we deliver 
            software development projects of any scale, complexity and type.
            <br />
          </p></div>
      </div>
      <div className="col-sm-12 col-md-6">
        <img src="./img/technology-stack.png" className="img-fluid img-tstack" />
      </div>
    </div>
  </div>
  {/*==========================
Clients Section
    ============================*/}
  <section id="clients" className="wow fadeInUp">
    <div className="container">
    <OwlCarousel items={6}  
          className="owl-carousel"  
          loop  
         >  
           <img src="./img/clients/c-original.svg" width={100} height={100} alt="" />
        <img src="./img/clients/angularjs-original.svg" width={100} height={100} alt="" />
        <img src="./img/clients/backbonejs-original.svg" width={100} height={100} alt="" />
        <img src="./img/clients/html5-original.svg" width={100} height={100} alt="" />
        <img src="./img/clients/css3-original.svg" width={100} height={100} alt="" />
        <img src="./img/clients/java-original.svg" width={100} height={100} alt="" />
        <img src="./img/clients/bootstrap-plain.svg" width={100} height={100} alt="" />
        <img src="./img/clients/nodejs-original.svg" width={100} height={100} alt="" />
        <img src="./img/clients/php-original.svg" width={100} height={100} alt="" />
        <img src="./img/clients/rails-original-wordmark.svg" width={100} height={100} alt="" />
        <img src="./img/clients/ruby-original.svg" width={100} height={100} alt="" />
        <img src="./img/clients/swift-original.svg" width={100} height={100} alt="" />
        <img src="./img/clients/visualstudio-plain.svg" width={100} height={100} alt="" />
        <img src="./img/clients/javascript-original.svg" width={100} height={100} alt="" />
        <img src="./img/clients/jquery-original.svg" width={100} height={100} alt="" />
        <img src="./img/clients/trello-plain.svg" width={100} height={100} alt="" />
        <img src="./img/clients/python-original.svg" width={100} height={100} alt="" />
        <img src="./img/clients/react-original.svg" width={100} height={100} alt="" />
        <img src="./img/clients/mysql-original.svg" width={100} height={100} alt="" />
        <img src="./img/clients/dot-net-original.svg" width={100} height={100} alt="" />
      </OwlCarousel>    
     
    </div>
  </section>{/* #clients */}
  {/*==========================
Services Section
    ============================*/}
  <section id="technology-stack">
    <div className="container">
      <div className="row">
        <div className="col-lg-6">
          <div className="box fadeInLeft">
            <h4 className="title">PROGRAMMING</h4>
            <hr color="crimson" />
            <p className="description">•  C#, Microsoft .net, WinForm, WPF, UWA,
              ASP.net, Enity Framework, nHibernate, ODBC. ADO.net <br />
              •  Java, Java Swing, JavaFX. JavaEE, Spring 
              Framework, Hibernate, JDBC <br />
              •  Android SDK <br />
              •  Swift for iOS <br />
              •  Javascript, JQuery, AngularJS, 
              Bootstrap, Google Maps JS API <br />
              •  Python <br />
              •  PHP, Laravel <br />
              •  Ruby, Ruby on Rails <br />
              •  Eclipse, Che, NetBeans, Microsoft Visual  Studio, Android Studio, Xcode <br />
              •  Microsoft Visio, Rational Rose <br />
              •  Git, SVN, Team Foundation Server <br />
              •  Maven, Gradle, Nuget <br />
              •  Microsoft Installer, Installshield
            </p>
          </div>
        </div>
        <div className="col-lg-6">
          <div className="box fadeInLeft">
            <h4 className="title">DATABASE</h4>
            <hr color="crimson" />
            <p className="description">•  Microsoft SQL Server <br />
              •  Oracle Database Server <br />
              •  MySQL <br />
              •  PostgreSQL <br />
              •  MongoDB<br />
              •  Apache Cassandra, Hadoop <br />
              •  DynamoDB</p>
          </div>
        </div>
        <div className="col-lg-6">
          <div className="box fadeInLeft">
            <h4 className="title">REPORTING</h4>
            <hr color="crimson" />
            <p className="description">•  iReport <br />
              •  Crystal Report <br />
              •  Microsoft Reporting Server <br />
              •  Microsoft Client reports <br />
              •  HTML5 <br />
              •  Charjs, Google Chart, Flot <br />
            </p>
          </div>
        </div>
        <div className="col-lg-6">
          <div className="box fadeInLeft">
            <h4 className="title">PROJECT MANAGEMENT</h4>
            <hr color="crimson" />
            <p className="description">•  Scrum, TDD, CI <br />
              •  Microsoft Project Server, Microsoft 
              Project  <br />
              •  Jira <br />
              •  Trello, Redmine <br />
            </p>
          </div>
        </div>
        <div className="col-lg-6">
          <div className="box fadeInLeft">
            <h4 className="title">TESTING</h4>
            <hr color="crimson" />
            <p className="description">•  MSTest <br />
              •  NUnit <br />
              •  JUnit <br />
              •  TestNG <br />
              •  Selenium (Java/C#/Python) <br />
              •  Apium <br />
              •  LoadRunner 
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>{/* #services */}
  {/*- Contact Us bar */}
  <div className="container contactus">
  <div className="row mb-5">
    <div className="col-lg-8 col-sm-12 align-self-center">
		<div className="d-flex justify-content-center">
		<span className="contact-text">Are you ready to work with us? Get in touch now!</span>
		</div>
        
     
    </div>
    <div className="col-lg-4 col-sm-12 align-self-center">
      <div className="d-flex justify-content-center">
		 <Link to="/ContactUs" className="contact-button"> CONTACT US NOW </Link>
      </div>
    </div>
  </div>
</div>
  
</div>

        </div>
    )
}

export default TechnologyStack
